<template>
  <v-dialog
    v-model="open"
    :max-width="$vuetify?.display?.xs ? null : 600"
    :fullscreen="$vuetify?.display?.xs"
  >
    <template v-slot:activator="{ props }">
      <v-list-item
        :title="t('i-wish-this-app-could')"
        class="ma-0"
        v-bind="props"
      >
        <template v-slot:prepend>
          <v-icon>mdi-message-text-outline</v-icon>
        </template>
      </v-list-item>
    </template>
    <v-card>
      <v-overlay :modelValue="loading" contained class="loading-container">
        <v-progress-circular indeterminate></v-progress-circular>
      </v-overlay>
      <v-overlay :modelValue="success" contained class="loading-container">
        <v-alert type="success">
          <span>{{ t("your-feedback-has-been-recorded-thank-you") }}</span>
          <v-icon @click="close">mdi-close</v-icon>
        </v-alert>
      </v-overlay>
      <v-overlay :modelValue="failed" contained class="loading-container">
        <v-alert type="error">
          <span>{{ t("error-please-try-again-later") }}</span>
          <v-icon @click="close">mdi-close</v-icon>
        </v-alert>
      </v-overlay>
      <v-toolbar color="secondary" dark max-height="64">
        <v-toolbar-title>{{ t("feedback-form") }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon large>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5">
        <p>
          {{ t("let-us-know-what-you") }}
        </p>
        <p>{{ t("the-more-context-you-provide-the-better") }}</p>
        <v-textarea
          outlined
          hide-details
          :placeholder="t('its-hard-for-me-to')"
          v-model="feedback"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn tonal elevation="0" color="white" @click="close">{{ t("cancel") }}</v-btn>
        <v-btn
          :disabled="!feedback"
          elevation="0"
          color="primary"
          @click="submit"
        >
          {{ t("submit") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref } from 'vue';
import { submitFeedback } from './feedbackapi';
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const loading = ref(false);
const open = ref(false);
const feedback = ref('');
const success = ref(false);
const failed = ref(false);

function close() {
  open.value = false;
  success.value = false;
  failed.value = false;
}
async function submit() {
  try {
    loading.value = true;
    await submitFeedback(feedback.value);
    feedback.value = '';
    success.value = true;
    setTimeout(close, 3000);
  } catch (e) {
    console.error(e);
    failed.value = true;
    setTimeout(close, 3000);
  } finally {
    loading.value = false;
  }
}
</script>
<i18n>
  {
    "en": {
      "i-wish-this-app-could": "I Wish This App Could...",
      "your-feedback-has-been-recorded-thank-you": "Your feedback has been recorded. Thank you!",
      "error-please-try-again-later": "Error. Please try again later.",
      "feedback-form": "Feedback Form",
      "let-us-know-what-you": "Let us know what you would like changed about our product and how that would help you. This will send your feedback to the teams at QSRSoft.",
      "the-more-context-you-provide-the-better": "The more context you provide, the better.",
      "its-hard-for-me-to": "It's hard for me to... I wish I could... I like ____ and I wish you did the same thing here...",
      "cancel": "Cancel",
      "submit": "Submit"
    },
    "es": {
      "i-wish-this-app-could": "Desearía que esta aplicación pudiera...",
      "your-feedback-has-been-recorded-thank-you": "Tu comentario ha sido registrado. ¡Gracias!",
      "error-please-try-again-later": "Error. Inténtalo de nuevo más tarde.",
      "feedback-form": "Formulario de comentarios",
      "let-us-know-what-you": "Cuéntenos qué cambios le gustaría que hiciéramos en nuestro producto y cómo eso lo ayudaría. Esto enviará sus comentarios a los equipos de QSRSoft.",
      "the-more-context-you-provide-the-better": "Cuanto más contexto proporciones, mejor.",
      "its-hard-for-me-to": "Es difícil para mí... Desearía poder... Me gusta ____ y desearía que hicieras lo mismo aquí...",
      "cancel": "Cancelar",
      "submit": "Enviar"
    }
  }
  </i18n>
<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
